import WarningTriangle from '../../../../assets/images/input/validation/warning.svg';
import Badge14 from '../../../../assets/new-images/badges/info/info.svg';
import Close14 from '../../../../assets/new-images/close/close-14.svg';
import Close18 from '../../../../assets/new-images/close/close-18.svg';
import Drag18 from '../../../../assets/new-images/interactions/drag/drag_icon_18.svg';
import ActivitiesPriority14 from '../../../../assets/new-images/icons/activities/priority/priority-14.svg';
import ActivitiesRedFlag14 from '../../../../assets/new-images/icons/activities/red-flag/red-flag-14.svg';
import ActivitiesStatus14 from '../../../../assets/new-images/icons/activities/status/status-14.svg';
import ActivitiesTags14 from '../../../../assets/new-images/icons/activities/tags/tags-14.svg';
import ActivitiesText14 from '../../../../assets/new-images/icons/activities/text/text-14.svg';
import ActivitiesUser14 from '../../../../assets/new-images/icons/activities/user/user-14.svg';
import Checkbox14 from '../../../../assets/new-images/icons/fields/checkbox/checkbox-14.svg';
import Cost14 from '../../../../assets/new-images/icons/fields/cost/cost-14.svg';
import Date14 from '../../../../assets/new-images/icons/fields/date/date-14.svg';
import FieldsDate18 from '../../../../assets/new-images/icons/fields/date/date-18.svg';
import Formula14 from '../../../../assets/new-images/icons/fields/formula/formula-14.svg';
import List14 from '../../../../assets/new-images/icons/fields/list/list-14.svg';
import List18 from '../../../../assets/new-images/icons/fields/list/list-18.svg';
import MultiList14 from '../../../../assets/new-images/icons/fields/multi-list/multi-list-14.svg';
import Numbers14 from '../../../../assets/new-images/icons/fields/numbers/numbers-14.svg';
import Percentage14 from '../../../../assets/new-images/icons/fields/percentage/percentage-14.svg';
import RichText14 from '../../../../assets/new-images/icons/fields/rich-text/rich-text-14.svg';
import Text14 from '../../../../assets/new-images/icons/fields/text/text-14.svg';
import Time14 from '../../../../assets/new-images/icons/fields/time/time-14.svg';
import Timeline14 from '../../../../assets/new-images/icons/fields/timeline/timeline-14.svg';
import DownArrow18 from '../../../../assets/new-images/icons/misc/down-arrow/down-arrow-18.svg';
import Mail18 from '../../../../assets/new-images/icons/misc/mail/mail-18.svg';
import Password18 from '../../../../assets/new-images/icons/misc/password/password-18.svg';
import UpArrow18 from '../../../../assets/new-images/icons/misc/up-arrow/up-arrow-18.svg';
import NavTableView14 from '../../../../assets/new-images/icons/nav/table-view/table-view-14.svg';
import ActivitiesBin18 from '../../../../assets/new-images/icons/activities/bin-icon/bin-icon-18.svg';
import RightArrow18 from '../../../../assets/new-images/icons/misc/right-arrow/right-arrow-18.svg';
import NotificationCheck18 from '../../../../assets/new-images/icons/notification-panel/notification-check/notification-check-18.svg';
import TableCollapseAll from '../../../../assets/new-images/icons/table-menu/collapse-all.svg';
import TableExpandAll from '../../../../assets/new-images/icons/table-menu/expand-all.svg';
import IntegrationVolyActiveSmall from '../../../../assets/new-images/integration/icons/voly-active-small.svg';
import IntegrationVolyInactiveSmall from '../../../../assets/new-images/integration/icons/voly-inactive-small.svg';
import ThreeDots from '../../../../assets/new-images/interactions/options/three-dots-vertical-5.svg';
import LinkAttachment from '../../../../assets/new-images/link-attachment/link-attachment.svg';
import ArrowBack14 from '../../../../assets/new-images/icons/left-menu/arrow/arrow-back-14.svg';
import ArrowLeft from '../../../../assets/images/arrows/arrow-left.svg';
import MiscArrowRight from '../../../../assets/new-images/icons/misc/right-arrow/right-arrow-14.svg';
import NavCog18 from '../../../../assets/new-images/icons/nav/cog/cog-18.svg';
import NavArrowRight18 from '../../../../assets/new-images/icons/nav/arrow-right/arrow-right-18.svg';
import NavArrowDown18 from '../../../../assets/new-images/icons/nav/arrow-down/arrow-down-18.svg';
import NavSearch18 from '../../../../assets/new-images/icons/nav/search/search-14.svg';
import NewSiteButton from '../../../../assets/images/plus/new-site-button.svg';
import IconNewSiteButton from '../../../../assets/new-images/plus/new-site-button.svg';
import NavThreeDotsVertical18 from '../../../../assets/new-images/icons/nav/three-dots-vertical/three-dots-vertical-18.svg';
import MiscClose14 from '../../../../assets/new-images/icons/misc/close/close-14.svg';
import SidePanelSiteListFolderClosed from '../../../../assets/images/side-panel/site-list-folder-open.svg';
import SidePanelSiteListFolderOpened from '../../../../assets/images/side-panel/site-list-folder-closed.svg';
import FavouriteActive16 from '../../../../assets/new-images/favourite-icon/favourite-icon-active-16.svg';
import FavouriteInactive16 from '../../../../assets/new-images/favourite-icon/favourite-icon-inactive-16.svg';
import PointInteractionOpenInSite from '../../../../assets/images/point-interactions/open-in-site.svg';
import InteractionClose from '../../../../assets/images/interactions/close/close.svg';
import IconMiscReminderIcon24 from '../../../../assets/new-images/icons/misc/reminder-icon/reminder-icon-24.svg';
import IconMiscCloseArrows24 from '../../../../assets/new-images/icons/misc/close-arrows/close-arrows-24.svg';
import IconMiscOpen24 from '../../../../assets/new-images/icons/misc/open/open-24.svg';
import IconMiscBellPlus24 from '../../../../assets/new-images/icons/misc/bell-plus/bell-plus-24.svg';
import IconMiscBell24 from '../../../../assets/new-images/icons/misc/bell/bell-24.svg';
import IconActivitiesRedFlagActivated24 from '../../../../assets/new-images/icons/activities/red-flag-activated/red-flag-activated-24.svg';
import IconActivitiesRedFlag24 from '../../../../assets/new-images/icons/activities/red-flag/red-flag-24.svg';
import IconMiscDownArrow24 from '../../../../assets/new-images/icons/misc/down-arrow/down-arrow-24.svg';
import IconMiscUpArrow24 from '../../../../assets/new-images/icons/misc/up-arrow/up-arrow-24.svg';
import IconActivitiesUser18 from '../../../../assets/new-images/icons/activities/user/user-18.svg';
import IconInputPlus32 from '../../../../assets/new-images/inputs/plus/plus-input-32.svg';
import IconMiscAttach18 from '../../../../assets/new-images/icons/misc/attach/attach-18.svg';
import IconFieldsTimeline18 from '../../../../assets/new-images/icons/fields/timeline/timeline-18.svg';
import IconActivitiesTags18 from '../../../../assets/new-images/icons/activities/tags/tags-18.svg';
import IconMiscAZ18 from '../../../../assets/new-images/icons/misc/a-z/a-z-18.svg';
import IconMiscZA18 from '../../../../assets/new-images/icons/misc/z-a/z-a-18.svg';
import IconBadgeInfoWhite from '../../../../assets/new-images/badges/info/info-white.svg';
import IconBannerWarning from '../../../../assets/new-images/misc/warning-banner.svg';
import IconBadgeWarning18 from '../../../../assets/new-images/banners/warning/warning-18.svg';
import TableAttachments from '../../../../assets/table-icons/table-attachments.svg';
import RelatedLink from '../../../../assets/new-images/icons/copy-link/link-attachment.svg';
import LogoSmallRebrand from '../../../../assets/icons/rebrand/favicon.svg';
import LogoHorizontalRebrand from '../../../../assets/new-images/badges/logos/pinpoint-works-horizontal-colour.svg';
import IconBadgeLogoVolyFinance from '../../../../assets/images/logos/voly-finance.svg';
import CustomFieldTextActivity from '../../../../assets/images/custom-fields/text/text-activity.svg';
import CustomFieldDateActivity from '../../../../assets/images/custom-fields/date/date-activity.svg';
import CustomFieldCostActivity from '../../../../assets/images/custom-fields/cost/cost-activity.svg';
import CustomFieldListActivity from '../../../../assets/images/custom-fields/list/list-activity.svg';
import CustomFieldNumbersActivity from '../../../../assets/images/custom-fields/numbers/numbers-activity.svg';
import CustomFieldRichTextActivity from '../../../../assets/images/custom-fields/rich-text/rich-text-activity.svg';
import CustomFieldTimeActivity from '../../../../assets/images/custom-fields/time/time-activity.svg';
import CustomFieldPercentageActivity from '../../../../assets/images/custom-fields/percentage/percentage-activity.svg';
import CustomFieldCheckboxActivity from '../../../../assets/images/custom-fields/checkbox/checkbox-activity.svg';
import CustomFieldTimelineActivity from '../../../../assets/images/custom-fields/timeline/timeline-activity.svg';
import CustomFieldMultiListActivity from '../../../../assets/images/custom-fields/multi-list/multi-list-activity.svg';
import IconFieldsFormula24 from '../../../../assets/new-images/icons/fields/formula/formula-24.svg';
import IntegrationVolyActiveBig from '../../../../assets/new-images/integration/icons/voly-active-big.svg';
import IntegrationVolyInactiveBig from '../../../../assets/new-images/integration/icons/voly-inactive-big.svg';
import SidePanelMenu from '../../../../assets/images/side-panel/menu.svg';
import GalleryClose from '../../../../assets/images/gallery/close.svg';
import IconBadgeStatusOpen14 from '../../../../assets/new-images/badges/status/open/open-14.svg';
import IconBadgeStatusInProgress14 from '../../../../assets/new-images/badges/status/in-progress/in-progress-14.svg';
import IconBadgeStatusToReview14 from '../../../../assets/new-images/badges/status/to-review/to-review-14.svg';
import IconBadgeStatusOnHold14 from '../../../../assets/new-images/badges/status/on-hold/on-hold-14.svg';
import IconBadgeStatusClosed14 from '../../../../assets/new-images/badges/status/closed/closed-14.svg';
import IconBadgeStatusCanceled14 from '../../../../assets/new-images/badges/status/canceled/canceled-14.svg';
import IconEdit from '../../../../assets/images/interactions/edit/edit.svg';
import { EIconPath } from './icons.enum';

export const iconMap = {
  [EIconPath.ICON_FIELDS_NUMBERS_14]: Numbers14,
  [EIconPath.ICON_FIELDS_FORMULA_14]: Formula14,
  [EIconPath.ICON_FIELDS_COST_14]: Cost14,
  [EIconPath.ICON_FIELDS_PERCENTAGE_14]: Percentage14,
  [EIconPath.ICON_THREE_DOTS]: ThreeDots,
  [EIconPath.ICON_TABLE_EXPAND_ALL]: TableExpandAll,
  [EIconPath.ICON_TABLE_COLLAPSE_ALL]: TableCollapseAll,
  [EIconPath.ICON_FIELDS_TEXT_14]: Text14,
  [EIconPath.ICON_ACTIVITIES_TEXT_14]: ActivitiesText14,
  [EIconPath.ICON_FIELDS_LIST_18]: List18,
  [EIconPath.ICON_FIELDS_LIST_14]: List14,
  [EIconPath.ICON_INTEGRATION_VOLY_ACTIVE_SMALL]: IntegrationVolyActiveSmall,
  [EIconPath.ICON_INTEGRATION_VOLY_INACTIVE_SMALL]: IntegrationVolyInactiveSmall,
  [EIconPath.ICON_FIELDS_MULTI_LIST_14]: MultiList14,
  [EIconPath.ICON_FIELDS_DATE_14]: Date14,
  [EIconPath.ICON_FIELDS_RICH_TEXT_14]: RichText14,
  [EIconPath.ICON_FIELDS_TIME_14]: Time14,
  [EIconPath.ICON_FIELDS_CHECKBOX_14]: Checkbox14,
  [EIconPath.ICON_FIELDS_TIMELINE_14]: Timeline14,
  [EIconPath.ICON_ACTIVITIES_PRIORITY_14]: ActivitiesPriority14,
  [EIconPath.ICON_ACTIVITIES_STATUS_14]: ActivitiesStatus14,
  [EIconPath.ICON_ACTIVITIES_USER_14]: ActivitiesUser14,
  [EIconPath.ICON_ACTIVITIES_TAGS_14]: ActivitiesTags14,
  [EIconPath.ICON_ACTIVITIES_RED_FLAG_14]: ActivitiesRedFlag14,
  [EIconPath.ICON_WARNING_TRIANGLE_ERROR]: WarningTriangle,
  [EIconPath.ICON_MISC_MAIL_18]: Mail18,
  [EIconPath.ICON_MISC_PASSWORD_18]: Password18,
  [EIconPath.ICON_BADGE_INFO]: Badge14,
  [EIconPath.ICON_MISC_UP_ARROW_18]: UpArrow18,
  [EIconPath.ICON_MISC_DOWN_ARROW_18]: DownArrow18,
  [EIconPath.ICON_CLOSE_14]: Close14,
  [EIconPath.ICON_CLOSE_18]: Close18,
  [EIconPath.ICON_DRAG_18]: Drag18,
  [EIconPath.ICON_FIELDS_DATE_18]: FieldsDate18,
  [EIconPath.ICON_NAV_TABLE_VIEW_14]: NavTableView14,
  [EIconPath.ICON_NOTIFICATION_CHECK_18]: NotificationCheck18,
  [EIconPath.ICON_BIN_18]: ActivitiesBin18,
  [EIconPath.ICON_MISC_RIGHT_ARROW_18]: RightArrow18,
  [EIconPath.ICON_LINK_ATTACHMENT]: LinkAttachment,
  [EIconPath.ICON_LEFT_MENU_ARROW_BACK_14]: ArrowBack14,
  [EIconPath.ARROW_LEFT]: ArrowLeft,
  [EIconPath.ICON_MISC_RIGHT_ARROW_14]: MiscArrowRight,
  [EIconPath.ICON_NAV_COG_18]: NavCog18,
  [EIconPath.ICON_NAV_ARROW_RIGHT_18]: NavArrowRight18,
  [EIconPath.ICON_NAV_ARROW_DOWN_18]: NavArrowDown18,
  [EIconPath.ICON_NAV_SEARCH_14]: NavSearch18,
  [EIconPath.PLUS_NEW_SITE]: NewSiteButton,
  [EIconPath.ICON_PLUS_NEW_SITE]: IconNewSiteButton,
  [EIconPath.ICON_NAV_THREE_DOTS_VERTICAL_18]: NavThreeDotsVertical18,
  [EIconPath.ICON_MISC_CLOSE_14]: MiscClose14,
  [EIconPath.SIDE_PANEL_SITE_LIST_FOLDER_CLOSED]: SidePanelSiteListFolderClosed,
  [EIconPath.SIDE_PANEL_SITE_LIST_FOLDER_OPENED]: SidePanelSiteListFolderOpened,
  [EIconPath.FAVOURITE_ACTIVE_16]: FavouriteActive16,
  [EIconPath.FAVOURITE_INACTIVE_16]: FavouriteInactive16,
  [EIconPath.POINT_INTERACTION_OPEN_IN_SITE]: PointInteractionOpenInSite,
  [EIconPath.INTERACTION_CLOSE]: InteractionClose,
  [EIconPath.ICON_MISC_REMINDER_ICON_24]: IconMiscReminderIcon24,
  [EIconPath.ICON_MISC_CLOSE_ARROWS_24]: IconMiscCloseArrows24,
  [EIconPath.ICON_MISC_OPEN_24]: IconMiscOpen24,
  [EIconPath.ICON_MISC_BELL_PLUS_24]: IconMiscBellPlus24,
  [EIconPath.ICON_MISC_BELL_24]: IconMiscBell24,
  [EIconPath.ICON_ACTIVITIES_RED_FLAG_ACTIVATED_24]: IconActivitiesRedFlagActivated24,
  [EIconPath.ICON_ACTIVITIES_RED_FLAG_24]: IconActivitiesRedFlag24,
  [EIconPath.ICON_MISC_DOWN_ARROW_24]: IconMiscDownArrow24,
  [EIconPath.ICON_MISC_UP_ARROW_24]: IconMiscUpArrow24,
  [EIconPath.ICON_ACTIVITIES_USER_18]: IconActivitiesUser18,
  [EIconPath.ICON_INPUT_PLUS_32]: IconInputPlus32,
  [EIconPath.ICON_MISC_ATTACH_18]: IconMiscAttach18,
  [EIconPath.ICON_FIELDS_TIMELINE_18]: IconFieldsTimeline18,
  [EIconPath.ICON_ACTIVITIES_TAGS_18]: IconActivitiesTags18,
  [EIconPath.ICON_MISC_A_Z_18]: IconMiscAZ18,
  [EIconPath.ICON_MISC_Z_A_18]: IconMiscZA18,
  [EIconPath.ICON_BADGE_INFO_WHITE]: IconBadgeInfoWhite,
  [EIconPath.ICON_BANNER_WARNING]: IconBannerWarning,
  [EIconPath.ICON_BADGE_WARNING_18]: IconBadgeWarning18,
  [EIconPath.ICON_TABLE_ATTACHMENTS]: TableAttachments,
  [EIconPath.ICON_RELATED_LINK]: RelatedLink,
  [EIconPath.LOGO_SMALL_REBRAND]: LogoSmallRebrand,
  [EIconPath.CUSTOM_FIELD_TEXT_ACTIVITY]: CustomFieldTextActivity,
  [EIconPath.CUSTOM_FIELD_DATE_ACTIVITY]: CustomFieldDateActivity,
  [EIconPath.CUSTOM_FIELD_COST_ACTIVITY]: CustomFieldCostActivity,
  [EIconPath.CUSTOM_FIELD_LIST_ACTIVITY]: CustomFieldListActivity,
  [EIconPath.CUSTOM_FIELD_NUMBERS_ACTIVITY]: CustomFieldNumbersActivity,
  [EIconPath.CUSTOM_FIELD_RICH_TEXT_ACTIVITY]: CustomFieldRichTextActivity,
  [EIconPath.CUSTOM_FIELD_TIME_ACTIVITY]: CustomFieldTimeActivity,
  [EIconPath.CUSTOM_FIELD_PERCENTAGE_ACTIVITY]: CustomFieldPercentageActivity,
  [EIconPath.CUSTOM_FIELD_CHECKBOX_ACTIVITY]: CustomFieldCheckboxActivity,
  [EIconPath.CUSTOM_FIELD_TIMELINE_ACTIVITY]: CustomFieldTimelineActivity,
  [EIconPath.CUSTOM_FIELD_MULTI_LIST_ACTIVITY]: CustomFieldMultiListActivity,
  [EIconPath.ICON_FIELDS_FORMULA_24]: IconFieldsFormula24,
  [EIconPath.ICON_INTEGRATION_VOLY_ACTIVE_BIG]: IntegrationVolyActiveBig,
  [EIconPath.ICON_INTEGRATION_VOLY_INACTIVE_BIG]: IntegrationVolyInactiveBig,
  [EIconPath.LOGO_HORIZONTAL_COLOUR_REBRAND]: LogoHorizontalRebrand,
  [EIconPath.ICON_BADGE_LOGO_VOLY_FINANCE]: IconBadgeLogoVolyFinance,
  [EIconPath.SIDE_PANEL_MENU]: SidePanelMenu,
  [EIconPath.GALLERY_CLOSE]: GalleryClose,
  [EIconPath.ICON_BADGE_STATUS_OPEN_14]: IconBadgeStatusOpen14,
  [EIconPath.ICON_BADGE_STATUS_IN_PROGRESS_14]: IconBadgeStatusInProgress14,
  [EIconPath.ICON_BADGE_STATUS_TO_REVIEW_14]: IconBadgeStatusToReview14,
  [EIconPath.ICON_BADGE_STATUS_ON_HOLD_14]: IconBadgeStatusOnHold14,
  [EIconPath.ICON_BADGE_STATUS_CLOSED_14]: IconBadgeStatusClosed14,
  [EIconPath.ICON_BADGE_STATUS_CANCELED_14]: IconBadgeStatusCanceled14,
  [EIconPath.INTERACTION_EDIT]: IconEdit,
};
